import React, { useState, useEffect, useRef } from 'react';
import "./ContactComponent.css";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'; // Alternative default style
import { getNames } from 'country-list';
import emailjs from '@emailjs/browser';

const ContactComponent = () => {
    const countries = getNames();

    const formRef = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            process.env.REACT_APP_EMAIL_SERVICES_KEY_CONTACT_FROM,
            process.env.REACT_APP_EMAIL_TEMPLATE_ID_CONTACT_FROM,
            formRef.current,
            process.env.REACT_APP_EMAIL_PUBLIC_KEY_CONTACT_FROM
        ).then(
            (result) => {
                alert("Message sent successfully!");
            },
            (error) => {
                alert("Something went wrong. Please try again.");
                console.error(error);
            }
        );
    };


    const [selectedCountry, setSelectedCountry] = useState('');

    const purposes = [
        "Sales",
        "Other"
    ];

    const [phone, setPhone] = useState("");


    return (
        <div className="contact-page-container">
            <div className="Page-Main_Dec">
                <h1 className="Page-title_LowerCase">Contact</h1>
            </div>
            <div className="contact-row">
                {/* Column 1: UK & Europe */}
                <div className="contact-column">
                    <h3>UK-Europe</h3>
                    <strong>UK Office :</strong>
                    <p>
                        Callistus UK Ltd.<br />
                        Magnolia House, Spring Villa Park, 11 Spring Villa Road<br />
                        Edgware HA8 7EB<br />
                        England
                    </p>
                    <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a>
                    <p>
                        Mobile: +44 11 332 06427<br />
                        Mobile: +44 7723 6199 26
                    </p>

                    <h4>United States</h4>
                    <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a>
                    <p>
                        Mobile: +1-646-466-5719<br />
                        Mobile: +1 506 499 7887
                    </p>
                </div>

                {/* Column 2: GCC */}
                <div className="contact-column">
                    <h3>GCC</h3>
                    <strong>Dubai Factory :</strong>
                    <p>
                        Callistus Blinds Middle East FZE<br />
                        Q4-109,110, SAIF Zone,<br />
                        Sharjah, UAE<br />
                        P.O. Box 120723
                    </p>
                    <a href="mailto:sales@callistusblinds.ae">sales@callistusblinds.ae</a>
                    <p>Mobile: +971 58 645 2901</p>

                    <h4>Canada</h4>
                    <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a>
                    <p>Mobile: +1 (438) 793 - 7489</p>
                </div>

                {/* Column 3: India */}
                <div className="contact-column">
                    <h3>India</h3>
                    <strong>India Factory :</strong>
                    <p>
                        Plot No. 210-211<br />
                        G. I. D. C Phase-II, Dared,<br />
                        Jamnagar - 361004<br />
                        Gujarat, INDIA
                    </p>
                    <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a><br />
                    <a href="mailto:info@callistusblinds.com">info@callistusblinds.com</a>

                    <h4>Australia</h4>
                    <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a>
                    <p>Mobile: +61 480 017 272</p>
                </div>
            </div>

            {/* Contact Form Section */}
            <div className="contact-form-section">
                <h3>Connect To Our Consultant</h3>
                <form className="contact-form" ref={formRef} onSubmit={sendEmail}>
                    <input type="hidden" name="form_type" value="Contact" />

                    {/* Full width fields */}
                    <div className="form-group full-width">
                        <label htmlFor="name">Name*</label>
                        <input type="text" id="name" name="name" placeholder="Your Name" required />
                    </div>

                    {/* Two column fields */}
                    <div className="form-row">
                        <div className="form-group half-width">
                            <label htmlFor="email">Email*</label>
                            <input type="email" id="email" name="email" placeholder="Your Email" required />
                        </div>
                        <div className="form-group half-width">
                            <label htmlFor="phone">Mobile*</label>
                            <PhoneInput
                                country={""}
                                enableSearch={true}
                                value={phone}
                                onChange={(phone) => setPhone(phone)}
                                placeholder="Your Number"
                                className="Pnum"
                                inputProps={{
                                    name: 'phone',
                                    required: true
                                }}
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group half-width">
                            <label htmlFor="city">City*</label>
                            <input type="text" id="city" name="city" placeholder="Your City" required />
                        </div>
                        <div className="form-group half-width">
                            <label htmlFor="state">State</label>
                            <input type="text" id="state" name="state" placeholder="Your State" required />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group half-width">
                            <label htmlFor="country">Country*</label>
                            <select id="country" name="country" value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)} required>
                                <option value="">Your Country</option>
                                {countries.map((country, idx) => (
                                    <option value={country} key={idx}>{country}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group half-width">
                            <label htmlFor="purpose">Purpose*</label>
                            <select id="purpose" name="purpose" required>
                                <option value="">Select Purpose</option>
                                {purposes.map((purpose, index) => (
                                    <option key={index} value={purpose}>{purpose}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Full width message field */}
                    <div className="form-group full-width message-field">
                        <label htmlFor="message">Message*</label>
                        <textarea id="message" name="message" placeholder="Your Message" required cols={40} rows={5}></textarea>
                    </div>

                    <button type="submit" className="submit-btn">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default ContactComponent;